var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioMissedCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16247",
    "data-name": "Group 16247",
    transform: "translate(723 -3284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13937",
    "data-name": "Path 13937",
    d: "M0,0H15V15H0Z",
    transform: "translate(-723 3284)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16216",
    "data-name": "Group 16216",
    transform: "translate(-723 3291.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_17",
    "data-name": "Union 17",
    d: "M12.941,6.328c-.127,0-.251,0-.381,0h-1.1a1.32,1.32,0,0,1-.972-.357A1.335,1.335,0,0,1,10.13,5c0-.114,0-.229,0-.342,0-.318,0-.645.012-.976a5.684,5.684,0,0,0-1.467-.334,9.906,9.906,0,0,0-3.2.155c-.1.023-.2.056-.314.092-.089.03-.183.062-.28.088L4.88,5a1.321,1.321,0,0,1-.362.957,1.276,1.276,0,0,1-.951.352l-2.223,0A1.258,1.258,0,0,1,.013,4.992c0-.174,0-.349,0-.519A6.831,6.831,0,0,0,0,3.747.059.059,0,0,1,0,3.73,2.071,2.071,0,0,1,.65,2.111c.042-.042.085-.082.129-.123A6.958,6.958,0,0,1,3.065.745,13.4,13.4,0,0,1,8.682.053a12.155,12.155,0,0,1,4.1,1.022,4.812,4.812,0,0,1,1.734,1.219A2.006,2.006,0,0,1,15,3.627L15,5.01a1.35,1.35,0,0,1-.373.946,1.311,1.311,0,0,1-.937.367c-.139.005-.283.008-.427.008Z",
    fill: "#ef0f0f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "missedcall-incoming",
    d: "M5.371.083a.282.282,0,0,0-.4,0l-4.4,4.4V2.065a.292.292,0,0,0-.241-.289A.283.283,0,0,0,0,2.057V5.171a.284.284,0,0,0,.283.283H3.108A.292.292,0,0,0,3.4,5.213a.283.283,0,0,0-.28-.325H.966l4.4-4.4a.285.285,0,0,0,0-.4Z",
    transform: "translate(-718.099 3284.737)",
    fill: "#ef0f0f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioMissedCall);
export default __webpack_public_path__ + "static/media/audioMissedCall.62ffe9f95f913196757df47437f60fad.svg";
export { ForwardRef as ReactComponent };